import Box from '@mui/material/Box';
import { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { Link } from '@tanstack/react-router';
import Typography from '@mui/material/Typography';
import { useGetByDevice } from '@onesource/components';
import { RycLogo } from '@onesource/icons';

const footerLinks = [
  { label: 'PRIVACY POLICY', link: 'https://laurenohayon.com/privacy-policy/' },
  { label: 'MEDICAL DISCLAIMER', link: 'https://laurenohayon.com/medical-disclaimer/' },
  { label: 'CONTACT', link: 'mailto:support@restoreyourcore.com' },
];

export const Footer: FC = () => {
  const theme = useTheme();
  const { isMobile } = useGetByDevice();

  return (
    <Box
      sx={{
        background: theme.palette.grey[900],
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          alignItems="center"
          justifyContent="space-between"
          sx={{
            height: { xs: '100px', md: '135px' },
            flexDirection: 'row',
            gap: {
              xs: 2,
            },
          }}
        >
          <RycLogo
            color={theme.palette.common.white}
            width={isMobile ? '91px' : '100px'}
            height={isMobile ? '58px' : '64px'}
          />

          <Box>
            <Box
              component="ul"
              sx={{
                display: 'flex',
                listStyle: 'none',
                flexDirection: { xs: 'column', md: 'row' },
                gap: { xs: 0.5, md: 3 },
                textAlign: { xs: 'right', md: 'left' },
              }}
            >
              {footerLinks.map(({ label, link }) => (
                <Box
                  component="li"
                  key={label}
                  sx={{
                    '& a': {
                      fontWeight: 500,
                      fontSize: { xs: '12px', md: '13px' },
                      color: theme.palette.common.white,
                      textDecoration: 'none',
                      transition: 'all 0.15s ease-in-out',
                      '&:hover': {
                        color: theme.palette.primary.main,
                      },
                    },
                  }}
                >
                  <Link target="_blank" to={link}>
                    {label}
                  </Link>
                </Box>
              ))}
            </Box>

            <Typography
              sx={{
                mt: 1.5,
                fontSize: { xs: '12px', md: '12px' },
                textAlign: { xs: 'center', md: 'right' },
                display: { xs: 'none', md: 'block' },
              }}
              color={theme.palette.grey[400]}
              fontWeight="400"
            >
              © {new Date().getFullYear()} RYC<sup>®</sup>. All rights reserved.
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Typography
        sx={{
          pb: 1.5,
          fontSize: '12px',
          textAlign: 'center',
          display: { xs: 'block', md: 'none' },
        }}
        color={theme.palette.grey[400]}
        fontWeight="400"
      >
        © {new Date().getFullYear()} RYC<sup>®</sup>. All rights reserved.
      </Typography>
    </Box>
  );
};
